import { render, staticRenderFns } from "./GitLab.vue?vue&type=template&id=114fd46e&scoped=true&lang=pug"
import script from "./GitLab.vue?vue&type=script&lang=js"
export * from "./GitLab.vue?vue&type=script&lang=js"
import style0 from "./GitLab.vue?vue&type=style&index=0&id=114fd46e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fd46e",
  null
  
)

export default component.exports